<template>
  <FlotoDrawerForm
    ref="drawer"
    width="40%"
    class="inline-block"
    @cancel="onCancel"
    @submit="onSubmit"
    @show="onShow"
  >
    <template v-slot:trigger="slotData">
      <slot name="trigger" v-bind="slotData"><span /></slot>
    </template>
    <template v-slot:header>
      <h5 class="mb-0"> {{ $t('add') }} {{ $tc('attribute', 2) }} </h5>
    </template>
    <FlotoContentLoader :loading="loading">
      <FlotoFixedView>
        <MInput
          v-model="query"
          auto-focus
          class="search-box mt-2 mb-4"
          :placeholder="$t('search')"
        >
          <template v-slot:prefix>
            <MIcon name="search" />
          </template>
        </MInput>
        <div :class="collapsibleColumnSelection ? 'ml-1' : 'ml-1 mb-2'">
          <MCheckbox
            :checked="data.columns.length === availableColumns.length"
            @change="handleSelectAll"
          >
            <strong>
              {{ $tc('select') }} {{ $tc('all') }}
              {{ $tc('field', 2) }}
            </strong>
          </MCheckbox>
        </div>
        <FlotoScrollView>
          <MRow v-if="!collapsibleColumnSelection" :gutter="0" class="pr-4">
            <ColumnSelectionList
              v-model="data.columns"
              :columns="availableColumns"
              :query="query"
            />
          </MRow>
          <MRow v-else class="pr-4" :gutter="0">
            <MCol>
              <MCollapse
                v-if="Object.keys(columnGroups).length"
                :accordion="false"
                class="my-4 collapse-menu"
                :default-active-key="Object.keys(columnGroups)[0]"
              >
                <MCollapsePanel
                  v-for="(c, group) in columnGroups"
                  :key="group"
                  :header="$tc(group)"
                >
                  <ColumnSelectionList
                    v-model="data.columns"
                    :collapsible-column-selection="collapsibleColumnSelection"
                    class="w-full -my-4"
                    :columns="c"
                    :all-columns="availableColumns"
                    :query="query"
                  />
                </MCollapsePanel>
              </MCollapse>
            </MCol>
          </MRow>
        </FlotoScrollView>
      </FlotoFixedView>
    </FlotoContentLoader>
    <template v-slot:actions="{ submit, hide }">
      <MButton
        id="add-btn"
        class="mx-1"
        variant="primary"
        :loading="processing"
        @click="submit"
      >
        {{ $t('add') }}
      </MButton>
      <MButton id="cancel-btn" variant="default" @click="hide">
        {{ $t('cancel') }}
      </MButton>
    </template>
  </FlotoDrawerForm>
</template>

<script>
import GroupBy from 'lodash/groupBy'
import { searchList } from '@utils/arr'
import ColumnSelectionList from '@modules/reports/components/form-components/column-selection-list'
export default {
  name: 'AddAttributeDrawer',
  components: { ColumnSelectionList },
  props: {
    availableColumns: { type: [Array, Object], required: true },
    defaultSelectedColumns: {
      type: Array,
      default() {
        return []
      },
    },
    // eslint-disable-next-line
    collapsibleColumnSelection: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: false,
      query: '',
      processing: false,
      data: {
        columns: [],
      },
    }
  },
  computed: {
    columnGroups() {
      if (this.collapsibleColumnSelection) {
        let col = this.availableColumns
        if (this.query) {
          col = searchList(this.availableColumns, this.query, 'text')
        }
        return GroupBy(col, 'groupName')
      }
      return {}
    },
  },
  watch: {
    defaultSelectedColumns(newValue) {
      this.getDefaultSelection(newValue)
    },
  },
  methods: {
    onShow() {
      this.getDefaultSelection(this.defaultSelectedColumns)
    },
    handleSelectAll(event) {
      if (event === true) {
        const availableColumns = this.availableColumns
        const selected = availableColumns.map((a) => a.key)
        // .filter((c) => {
        //   const keys = c.split('.')
        //   const key = keys[keys.length - 1]
        //   return key
        // })
        this.data = {
          ...this.data,
          columns: selected,
        }
      } else {
        this.data = {
          ...this.data,
          columns: [],
        }
      }
    },
    onCancel() {
      this.data = {
        columns: [],
      }
      this.query = ''
      this.$refs.drawer.hide()
    },
    onSubmit() {
      const columns = this.availableColumns.filter(
        (c) => this.data.columns.indexOf(c.key) >= 0
      )
      this.$emit('submit', columns)
      this.query = ''
      this.$refs.drawer.hide()
    },
    getDefaultSelection(columns) {
      const availableColumns = this.availableColumns
      const selected = availableColumns
        .map((a) => a.key)
        .filter((key) => {
          // const keys = c.split('.')
          // const key = keys[keys.length - 1]
          return columns.indexOf(key) >= 0
        })
      this.data = {
        ...this.data,
        columns: selected,
      }
    },
  },
}
</script>
